import { EVENT_NAME as CHECKBOX_EVENT } from '@adobe-fonts/site/events/FontVariationCardCheckboxEvent.js';
import LibrariesToggleEvent from '@adobe-fonts/site/events/LibrariesToggleEvent.js';
import { getLibraryElementData } from '../../../util/libraries.js';

export class VariationCardCheckbox {
  constructor(element) {
    this.element = element;
  }

  handleCheckboxEvent = async (event) => {
    const card = event.target;
    const libraryElements = getLibraryElementData(card);
    if (!libraryElements) {
      return;
    }
    const checked = !card.hasAttribute('selected');
    this.element.dispatchEvent(new LibrariesToggleEvent({
      checked: checked,
      libraryElements: libraryElements
    }));

    this._updateSettingsBar(checked);
    this._updateLibrariesToolbar(card, checked);
  };

  _updateSettingsBar = (checked) => {
    this.element.checkedVariationsCount += checked ? 1 : -1;
    const method = this.element.checkedVariationsCount === 0 ? 'remove' : 'add';
    this.element._settingsBar.classList[method]('hide');
  };

  /**
   * Updates the libraries toolbar's sync state, so that it stays consistent
   * with the synced state of the selected variation cards.
   *
   * @param {HTMLElement} togglingCard The card being toggled
   * @param {boolean} checked true if the card is being selected, false if deselected
   */
  _updateLibrariesToolbar = (togglingCard, checked) => {
    const toolbar = this.element._librariesToolbar;

    // The toolbar is synced if all the selected cards are synced
    toolbar.synced = Array.from(this.element._variationCards)
      .filter(card => this._isSelectedCard(card, togglingCard, checked))
      .map(card => card.querySelector('af-sync-button'))
      .every(syncButton => syncButton.synced);

    // The toolbar is favorited if at least one of the selected cards are favorited
    toolbar.favorited = Array.from(this.element._variationCards)
      .filter(card => this._isSelectedCard(card, togglingCard, checked))
      .map(card => card.querySelector('af-favorite-button'))
      .some(favoriteButton => favoriteButton.selected);
  };

  /**
   * Helper method to check if the card is one of the selected cards.
   *
   * We need this method because the card's `selected` attribute isn't updated
   * until after this event handler runs.
   *
   * @param {HTMLElement} card The card that is being checked
   * @param {HTMLElement} togglingCard The card that fired the checkbox event
   * @param {boolean} checked true if the card is being selected, false if deselected
   */
  _isSelectedCard = (card, togglingCard, checked) => {
    return checked ?
      card === togglingCard || card.selected :
      card !== togglingCard && card.selected;
  };
}

export function registerEventHandlers(element) {
  const variationCardCheckbox = new VariationCardCheckbox(element);
  element.addEventListener(CHECKBOX_EVENT, variationCardCheckbox.handleCheckboxEvent);
}
